import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import React, { Component } from "react";
import config from "../config";
// TODO: ProblemViewとの処理の共通化
const styles = (theme) => ({
  root: {
    // display: 'flex',
  },
  problem: {
    width: "100%",
  },
});
class SolutionView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      results: [],
      answers: [],
      correct: [],
    };
  }
  componentDidMount() {
    return fetch(config.backend_url + "contests/" + this.props.contest_id + "/problems").then(
      (response) => {
        response.json().then((json) => {
          this.setState({ results: json, loading: false });
        });
      }
    );
  }
  render() {
    const { classes } = this.props;
    if (this.state.loading) {
      return <p>Loading...</p>;
    }
    if (this.state.results.problems == null) {
      return <p>コンテスト終了後に解答は公開されます</p>;
    }
    return (
      <div className={classes.root}>
        {(this.state.results.problems !== null
          ? this.state.results.problems
          : []
        ).map((problem, idx) => {
          return (
            <Card>
              <CardContent>
                <div align="center">
                  <Typography
                    className={classes.title}
                    color="textSecondary"
                    gutterBottom
                  >
                    {problem.title}
                  </Typography>

                  <img
                    class={classes.problem}
                    src={problem.image_url.replace("problems", "solutions")}
                    alt="答え"
                  ></img>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>
    );
  }
}

SolutionView.propTypes = {
  contest_id: PropTypes.string.isRequired,
};

export default withStyles(styles)(SolutionView);
